import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=9c0277f4&"
import script from "./UserDetail.ts?vue&type=script&lang=ts&"
export * from "./UserDetail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports